export const routes = {
  account: {
    settings: 'account/settings',
  },
  auth: {
    me: 'auth/me',
  },
  users: {
    list: (tenantId: string) => `tenants/${tenantId}/users`,
    invite: (tenantId: string) => `tenants/${tenantId}/users`,
  },
  clients: {
    list: (tenantId: string) => `tenants/${tenantId}/clients`,
    create: (tenantId: string) => `tenants/${tenantId}/clients`,
    research: (tenantId: string) => `tenants/${tenantId}/clients/research`,
    get: (tenantId: string, clientId: string) => `tenants/${tenantId}/clients/${clientId}`,
    update: (tenantId: string, clientId: string) => `tenants/${tenantId}/clients/${clientId}`,
    delete: (tenantId: string, clientId: string) => `tenants/${tenantId}/clients/${clientId}`,
  },
  proposals: {
    create: (tenantId: string) => `tenants/${tenantId}/proposals`,
    list: (tenantId: string) => `tenants/${tenantId}/proposals`,
    get: (tenantId: string, proposalId: string) => `tenants/${tenantId}/proposals/${proposalId}`,
    update: (tenantId: string, proposalId: string) => `tenants/${tenantId}/proposals/${proposalId}`,
    delete: (tenantId: string, proposalId: string) => `tenants/${tenantId}/proposals/${proposalId}`,
    generate: (tenantId: string, proposalId: string) => `tenants/${tenantId}/proposals/${proposalId}/generate`,
    generateSection: (tenantId: string, proposalId: string) =>
      `tenants/${tenantId}/proposals/${proposalId}/sections/generate`,
    prepareSend: (tenantId: string, proposalId: string) => `tenants/${tenantId}/proposals/${proposalId}/prepare-send`,
    send: (tenantId: string, proposalId: string) => `tenants/${tenantId}/proposals/${proposalId}/send`,
    presignAsset: (tenantId: string, proposalId: string) =>
      `tenants/${tenantId}/proposals/${proposalId}/assets/presign`,
    rewriteBlock: (tenantId: string, proposalId: string, blockId: string) =>
      `tenants/${tenantId}/proposals/${proposalId}/blocks/${blockId}/rewrite`,
    listByClient: (tenantId: string, clientId: string) => `tenants/${tenantId}/clients/${clientId}/proposals`,
  },
  templates: {
    list: (tenantId: string) => `tenants/${tenantId}/templates`,
  },
  proposalSectionTypes: {
    list: () => 'section-types',
  },
  public: {
    getProposal: (token: string) => `public/proposal/${token}`,
    signProposal: (token: string) => `public/proposal/${token}/sign`,
  },
  visitor: {
    listSectionTypes: () => 'visitor/section-types',
    generateProposal: () => 'visitor/proposals/generate',
    getProposal: (visitorProposalId: string) => `visitor/proposals/${visitorProposalId}`,
    updateProposal: (visitorProposalId: string) => `visitor/proposals/${visitorProposalId}`,
    generateSection: (visitorProposalId: string) => `visitor/proposals/${visitorProposalId}/sections/generate`,
    rewriteBlock: (visitorProposalId: string, blockId: string) =>
      `visitor/proposals/${visitorProposalId}/blocks/${blockId}/rewrite`,
    claimProposal: (visitorProposalId: string) => `visitor/proposals/${visitorProposalId}/claim`,
  },
};
